import { z } from 'zod'

import { DateZod } from '../common'

export const BlockedSmsNumberZod = z.object({
  blocked: z.boolean(),
  blockedAt: DateZod.nullish().default(null),
  lastEventAt: DateZod.nullish().default(null),
})
